import { Fragment, PureComponent, ReactNode } from 'react';
import { TreatmentPlan } from '../../../../../api/getTreatmentPlans';
import { formattedNumber } from '../../../../../pages/utils';

interface Props {
    treatmentPlan: TreatmentPlan;
}

class TreatmentPricing extends PureComponent<Props> {
    render(): ReactNode {
        const { treatmentPlan } = this.props;
        const { discount = 0, services } = treatmentPlan;
        const totalMrp = services.reduce((acc, cur) => acc + cur.mrp, 0);
        const totalAmount = services.reduce((acc, cur) => acc + cur.amount, 0);
        const lineItemDiscount = totalMrp - totalAmount;
        const additionalDiscount = (discount / 100) * totalAmount;
        const amountToBePaid = totalAmount - additionalDiscount;

        return (
            <div className="border border-darwin-neutral_new-200 px-20 py-15 rounded-8 space-y-8 bg-white">
                {lineItemDiscount > 0 && (
                    <Fragment>
                        <div className="flex items-center justify-between">
                            <p className="uppercase text-11 font-700 font-700">Total MRP:</p>
                            <p className="text-13 text-darwin-neutrals-1000">
                                ₹{formattedNumber(totalMrp)}
                            </p>
                        </div>
                        <div className="flex items-center justify-between">
                            <p className="uppercase text-11 font-700 font-700">
                                Line item discount:
                            </p>
                            <p className="text-13 text-darwin-green-primary">
                                ₹{formattedNumber(lineItemDiscount)}
                            </p>
                        </div>
                    </Fragment>
                )}
                <div className="flex items-center justify-between">
                    <p className="uppercase text-11 font-700 font-700">Total Amount:</p>
                    <p className="text-13 text-darwin-neutrals-1000">
                        ₹{formattedNumber(totalAmount)}
                    </p>
                </div>
                {additionalDiscount > 0 && (
                    <div className="flex items-center justify-between">
                        <p className="uppercase text-11 font-700 font-700">Additional Discount:</p>
                        <p className="text-13 text-darwin-green-primary">
                            ₹{formattedNumber(additionalDiscount)}
                        </p>
                    </div>
                )}
                <div className="border-t border-darwin-neutral_new-200"></div>
                <div className="flex items-center justify-between">
                    <p className="uppercase text-11 font-700 font-700">Amount to be paid:</p>
                    <p className="text-13 text-darwin-neutrals-1000 font-700">
                        ₹{formattedNumber(amountToBePaid)}
                    </p>
                </div>
            </div>
        );
    }
}

export default TreatmentPricing;
